import { GhostButton, DeleteButton } from "src/components/Buttons";
import {
  Container,
  FilterRow,
  Header,
  Heading,
  Input,
  Select,
} from "./SearchDealers.styles";

interface DealerFilter {
  field: string;
  value: string;
}

interface SearchDealersProps {
  loading: boolean;
  filters: DealerFilter[];
  setFilters: (filters: DealerFilter[]) => void;
  objectKeys: string[];
}

export default function SearchDealers({
  loading,
  filters,
  setFilters,
  objectKeys,
}: SearchDealersProps) {
  const addFilter = () => {
    setFilters([...filters, { field: "name", value: "" }]);
  };

  const updateFilter = (
    index: number,
    key: keyof DealerFilter,
    newValue: string,
  ) => {
    const newFilters = [...filters];
    newFilters[index][key] = newValue;
    setFilters(newFilters);
  };

  const removeFilter = (index: number) => {
    setFilters(filters.filter((_, i) => i !== index));
  };

  return (
    <Container>
      <Header>
        <Heading>Search Dealers</Heading>

        <GhostButton initialBg={true} loading={loading} onClick={addFilter}>
          Add Filter
        </GhostButton>
      </Header>
      {filters.map((filter, index) => (
        <FilterRow key={index}>
          <Select
            value={filter.field}
            onChange={(e) => updateFilter(index, "field", e.target.value)}
          >
            {objectKeys?.map((opt) => (
              <option key={opt} value={opt}>
                {opt}
              </option>
            ))}
          </Select>
          <Input
            type="text"
            value={filter.value}
            onChange={(e) => updateFilter(index, "value", e.target.value)}
          />
          <DeleteButton onClick={() => removeFilter(index)}>
            Remove
          </DeleteButton>
        </FilterRow>
      ))}
    </Container>
  );
}
